import { ReactNode } from "react";
import Header from "../components/header";
import "./layout.css";

interface LayoutProps {
  children: ReactNode;
}

const Layout = (props: LayoutProps) => {
  const { children } = props;
  return (
    <div className="main_layout">
      <Header />
      {children}
    </div>
  );
};

export default Layout;
